module.exports = __webpack_public_path__ + "usa-54d68bd8073bab5b9cc76f10b7ba4105.png";